import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="raw-data-display"
export default class extends Controller {
  // Targets for the summary section and the table body
  static targets = [ "summaryValueDate", "summaryDirection", "summaryAmount", "rawDataTable" ]

  connect() {
    this.element.addEventListener('show.bs.offcanvas', event => {
      const button = event.relatedTarget // Button that triggered the modal
      if (!button) return; // Exit if no related target

      // Extract summary info from data-bs-* attributes
      const valueDate = button.getAttribute('data-bs-value-date')
      const direction = button.getAttribute('data-bs-direction')
      const amount = button.getAttribute('data-bs-amount')
      const rawDataString = button.getAttribute('data-bs-raw-data');

      // Update the summary content.
      this.summaryValueDateTarget.textContent = valueDate || '-'
      this.summaryDirectionTarget.textContent = direction || '-'
      this.summaryAmountTarget.textContent = amount || '-'

      // Parse raw data
      let rawData = {};
      try {
          rawData = JSON.parse(rawDataString || '{}');
      } catch (e) {
          console.error("Error parsing raw data JSON:", e);
          rawData = { error: "Could not parse data" };
      }

      // Get the table body element
      const tbody = this.rawDataTableTarget.querySelector('tbody');
      if (!tbody) return; // Exit if tbody not found

      tbody.innerHTML = ''; // Clear existing content

      // Sort entries: non-null/non-empty values first, then null/empty values
      const entries = Object.entries(rawData).sort((a, b) => {
        const aIsNull = a[1] === null || a[1] === '';
        const bIsNull = b[1] === null || b[1] === '';
        if (aIsNull && !bIsNull) return 1;
        if (!aIsNull && bIsNull) return -1;
        // Optional: secondary sort by key if both null/not null
        return a[0].localeCompare(b[0]); 
      });

      // Add each key-value pair to the table
      entries.forEach(([key, value]) => {
        const row = tbody.insertRow();
        const displayValue = value === null || value === '' ? '<span class="text-muted">null</span>' : value;
        row.innerHTML = `
          <td><strong>${key}</strong></td>
          <td class="text-end">${displayValue}</td>
        `;
      });
    })
  }

  disconnect() {
    // Stimulus generally handles listener removal, but you could add explicit removal if needed
    // this.element.removeEventListener('show.bs.offcanvas', ...)
  }
} 